import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {AnyRouteResult} from '@/app/interfaces/routing';
import {RouteName} from '@/app/constants/routing';
import {Interpolation} from '@/common/services/localizer';
import {useRoute} from '@/common/services/router';
import {useUrlBuilder} from '@/app/routing/useUrlBuilder';
import {selectDomainConfig} from '@/app/store/config/selectors';
import {RouterLink} from '@/common/components/RouterLink';
import {TextLink} from '@/common/components/TextLink';
import styles from './AppPreFooter.css';

export const AppPreFooter = memo(() => {
	const {domainName} = useSelector(selectDomainConfig);
	const {route} = useRoute<AnyRouteResult>();
	const urlBuilder = useUrlBuilder();
	const mainPageUrl = urlBuilder(RouteName.mainPage, {});

	if (route.name === RouteName.mainPage || route.name === RouteName.notFound) {
		return null;
	}

	return (
		<p className={styles.root}>
			<Interpolation
				l10nCode={`mainPageLink.${domainName}`}
				link={text => (
					<RouterLink url={mainPageUrl} component={TextLink}>
						{text}
					</RouterLink>
				)}
			/>
		</p>
	);
});

AppPreFooter.displayName = 'AppPreFooter';
